var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateAlertSpeedGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9565 0.739746H7.04348L0 7.78323V17.6963L7.04348 24.7397H16.9565L24 17.6963V7.78323L16.9565 0.739746Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2191 11.9136H22.306C22.0887 9.82663 21.2626 7.91358 20.0017 6.39185L18.5234 7.87011C19.4365 9.04402 20.0452 10.3918 20.2191 11.9136Z",
    fill: "#00AD00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0864 6.43544L18.5647 4.95718C17.043 3.69631 15.1299 2.87022 13.043 2.65283V4.73979C14.5212 4.9137 15.9125 5.5224 17.0864 6.43544Z",
    fill: "#00AD00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9553 4.73979V2.65283C8.86838 2.87022 6.95533 3.69631 5.43359 4.95718L6.91185 6.43544C8.04229 5.5224 9.43359 4.9137 10.9553 4.73979Z",
    fill: "#00AD00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95669 6.39185C2.69582 7.95706 1.86974 9.87011 1.65234 11.9136H3.7393C3.91321 10.3918 4.52191 9.00054 5.43495 7.87011L3.95669 6.39185Z",
    fill: "#00AD00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4315 8.07227L13.1075 16.6239H10.9163L10.5924 8.07227H13.4315ZM10.5156 19.2755C10.5156 18.8946 10.652 18.5735 10.9249 18.312C11.1977 18.0506 11.5586 17.9198 12.0077 17.9198C12.451 17.9198 12.8063 18.0506 13.0734 18.312C13.3463 18.5735 13.4827 18.8946 13.4827 19.2755C13.4827 19.662 13.3463 19.986 13.0734 20.2474C12.8063 20.5032 12.451 20.6311 12.0077 20.6311C11.5586 20.6311 11.1977 20.5032 10.9249 20.2474C10.652 19.986 10.5156 19.662 10.5156 19.2755Z",
    fill: "#00AD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAlertSpeedGreen);
export default __webpack_public_path__ + "static/media/create-alert-speed-green.c474422382745c2d3c0b2f9aa389bc1b.svg";
export { ForwardRef as ReactComponent };